import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
    padding: 1rem 0.6rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    justify-content: center;
`

export const CustomTextField = styled(TextFieldMui)`
    margin: 0 !important;
    width: 22rem !important;

    & input {
        height: 1rem !important;
    }
`

export const CustomButton = styled(ButtonMui)`
    width: 20rem !important;    
    height: 3rem !important;
    margin: 0 !important;
`

export const ContainerButton = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 0.9rem;
    gap: 1rem;
    align-items: center;
    width: 100%;
`

export const CustomTextWrapper = styled.div`
  height: 3rem !important;
`
